<template>
  <!--  提示确认框  -->
  <el-dialog
    :visible.sync="tipDialog"
    :custom-class="dialogClass"
    :title="isHeaderStyle ? title : ''"
    :show-close="isHeaderStyle ? true : showClose"
    :width="`${width}px`"
    :close-on-click-modal="closeOnOther"
    :close-on-press-escape="closeOnOther"
    @close="close()"
    :top="top"
    center
  >
    <div id="tipDialog" :style="{ padding: boxPadding }">
      <div class="title" v-if="title && !isHeaderStyle">{{ title }}</div>
      <div class="text" v-if="text" v-html="text"></div>
      <slot name="content"></slot>
      <slot name="btn">
        <div class="btn" id="my-dialog-btn" @click="btnFuc">{{ btnText }}</div>
      </slot>
      <slot name="tip">

      </slot>
      <img
        class="close"
        v-if="closeBtnShow && !isHeaderStyle"
        src="@/assets/image/AccountDeal/close.png"
        alt=""
        @click="close()"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "myDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    btn: {
      type: Boolean,
      default: false,
    },
    btnGroup: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: "",
    },
    btnFuc: {
      type: Function,
      default: () => {},
    },
    width: {
      type: String,
      Number,
      default: "358",
    },
    top: {
      type: String,
      default: "35vh",
    },
    customClass: {
      type: String,
      default: "tipDialog",
    },
    closeFun: {
      type: Function,
      default: null,
    },
    closeBtnShow: {
      type: Boolean,
      default: true,
    },
    closeOnOther: {
      type: Boolean,
      default: true,
    },
    // 是否显示右上角关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    boxPadding: {
      type: String,
      default: "26px 34px",
    },
    dialogStyle: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      tipDialog: this.show,
    };
  },
  computed: {
    isHeaderStyle() {
      return this.dialogStyle === "header";
    },
    dialogClass() {
      return `${this.customClass} myDialog ${this.isHeaderStyle ? "myDialog--header" : "myDialog--default"}`;
    },
  },
  methods: {
    close() {
      if (this.closeFun) {
        this.closeFun();
      }
    },
  },
  watch: {
    show(val) {
      this.tipDialog = val;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header,
/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.myDialog {
  overflow: visible;
  border-radius: 4px;
  box-shadow: none;
  background: var(--bg-card, #FFFFFF);
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__body {
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
  }

  #tipDialog {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    .title {
      margin: 0 0 18px;
      font-size: 18px;
      line-height: 24px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #111827);
      text-align: center;
    }

    .text {
      width: 100%;
      max-width: 289px;
      margin: 0 0 24px;
      font-size: 15px;
      line-height: 24px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      text-align: center;
    }

    .btn {
      width: 200px;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: center;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
    }

    .btn:hover {
      background: var(--primary-hover, #E84A12);
      box-shadow: 0 10px 22px rgba(255, 90, 31, 0.20);
      opacity: 1;
    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -42px;
      left: calc(50% - 15px);
      cursor: pointer;
      opacity: .92;
      transition: opacity .2s ease, transform .2s ease;
    }

    .close:hover {
      opacity: 1;
      transform: rotate(90deg);
    }
  }
}

/deep/.myDialog--header {
  overflow: hidden;

  .el-dialog__header{
    height: 54px;
    padding: 0;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    text-align: center;
  }

  .el-dialog__title{
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
    letter-spacing: 1px;
  }

  .el-dialog__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-dialog__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .el-dialog__headerbtn:hover .el-dialog__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .el-dialog__body {
    border-radius: 0 0 4px 4px;
  }

  #tipDialog {
    border-radius: 0 0 4px 4px;
  }
}
</style>
